import { api } from '@/api/api';
import { apis } from '@/config';
import { activityConf } from './activity-conf';
const activity_key = 'webmail_lx_note_v2';
class WebmailApiImpl {
    constructor() {
        this._activityId = 0;
        this.name = apis.webmailApiImpl;
        this.httpApi = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
        this._webmailState = {};
    }
    init() {
        return this.name;
    }
    getUrl(url) {
        return this.systemApi.getUrl(url);
    }
    parseResult(res) {
        return res.data || {};
    }
    catchError(reason) {
        return reason;
    }
    getActivityInfo() {
        return this.httpApi.get(this.getUrl('getActivityInfo'), {}, { contentType: 'form' }).then(res => {
            var _a, _b;
            const activityInfos = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.activityInfos;
            if (activityInfos != null) {
                const info = activityInfos.find(item => item.type === activity_key);
                this._activityId = (info === null || info === void 0 ? void 0 : info.activityId) || 0;
            }
            else {
                throw new Error('获取活动详情失败，请重试');
            }
            return this.parseResult(res);
        }, () => {
            throw new Error('获取活动详情失败，请重试');
        });
    }
    getActivityPop() {
        return this.httpApi.get(this.getUrl('getActivityPop'), {}, { contentType: 'form' });
    }
    getLongTail() {
        return this.httpApi.get(this.getUrl('getLongTail'), {}, { contentType: 'form' });
    }
    joinActivity(option) {
        return this.httpApi
            .post(this.getUrl('joinActivity'), option, {
            contentType: 'form',
        })
            .then(this.parseResult, err => {
            var _a;
            console.log(err);
            const code = (_a = err.data) === null || _a === void 0 ? void 0 : _a.code;
            if (code === 30000) {
                throw new Error('活动已截至');
            }
            if (code === 30001) {
                throw new Error('无法参与报名');
            }
            throw new Error('报名失败，请重试');
        });
    }
    invokeActivity(option) {
        return this.httpApi.post(this.getUrl('invokeActivity'), option, { contentType: 'form' }).then(this.parseResult).catch(this.catchError);
    }
    doInvokeActivity(tid, activityId) {
        const time = Date.now();
        const { startTime, endTime } = this.getTimeRange().yun_bi_ji;
        if (time > startTime && time < endTime) {
            this.invokeActivity({
                activityId,
                tid,
            });
        }
    }
    getTimeRange() {
        return activityConf;
    }
    setState(state) {
        this._webmailState = state;
    }
    getState() {
        return this._webmailState;
    }
}
const webmailApiImpl = new WebmailApiImpl();
api.registerLogicalApi(webmailApiImpl);
export default webmailApiImpl;
